import { useFleets } from "@src/settings"
import { useTranslation } from "react-i18next"
import Form from "react-bootstrap/Form"
import { FLEETS } from "@src/settings"
import React, { useEffect, useState } from "react"

type FleetDropDownProps = {
  withoutAllOption?: boolean
  fleetUpdate?: boolean
  onClick: (fleet: FLEETS) => void
}

export const FleetDropDown: React.FC<FleetDropDownProps> = ({
  onClick,
  withoutAllOption,
  fleetUpdate,
}) => {
  const { updateFleetUuid, fleets, fleet } = useFleets()
  const [updateFleet, setUpdateFleet] = useState<boolean>(true)
  const { t } = useTranslation()
  var allDeviceOption = withoutAllOption ? "" : t("select_fleet_screen.all_fleets")

  useEffect(() => {
    if (fleetUpdate) setUpdateFleet(fleetUpdate)
    if (withoutAllOption && fleets && fleets.length !== 0) {
      updateFleetUuid(fleets[0].uuid)
    }
  }, [fleetUpdate, withoutAllOption, fleets])

  useEffect(() => {
    if (fleetUpdate) setUpdateFleet(fleetUpdate)
    if (withoutAllOption && fleets && fleets.length !== 0) {
      updateFleetUuid(fleets[0].uuid)
    }
  }, [fleetUpdate, withoutAllOption, fleets])

  const onSelectFleet = (fleet?: FLEETS) => {
    const defaultFirstFleet = withoutAllOption ? fleets[0]?.uuid : ""
    if (updateFleet) updateFleetUuid(fleet ? fleet.uuid : defaultFirstFleet)
    onClick(fleet)
  }

  return (
    <>
      {fleets && fleets.length !== 0 && (
        <div>
          <Form.Select
            name="fleets"
            id="fleets"
            onChange={(event) => {
              const fleetItem = fleets.filter((el) => el.uuid === event.target.value)
              onSelectFleet(fleetItem[0])
            }}
            defaultValue={fleet ? fleet.uuid : allDeviceOption}
          >
            {fleets.map((item) => (
              <option key={item.uuid} value={item.uuid}>
                {item.name}
              </option>
            ))}
            {!withoutAllOption && (
              <option
                value={t("select_fleet_screen.all_fleets")}
                onClick={() => onSelectFleet(null)}
              >
                {t("select_fleet_screen.all_fleets")}
              </option>
            )}
          </Form.Select>
        </div>
      )}
    </>
  )
}
